// **********************************************************
// Product Popup
// **********************************************************

const popupRelatedProductEle = document.querySelectorAll('[data-slider="product-popup-related-slider"]');

const axiosGetProducts = async (id) => {
  const action = 'getProductModal';

  const formDataInput = {
    action,
    id,
  };

  try {
    const { data } = await axios.post(localData.siteURL, formDataInput);
    document.querySelector('.product-popup').innerHTML = data.data.html;
  } catch (err) {
    console.error(err);
  }
};

const popupRelatedProductEleOpt = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  speed: 400,
  mousewheel: {
    forceToAxis: true,
  },
};

popupRelatedProductEle.forEach((el) => new Swiper(el, popupRelatedProductEleOpt));

// Modal Control
const toggleProductPopup = (toggle) => {
  document.body.classList.toggle('is-open-product-popup', toggle);
};

attachEvent('.portfolio-card', 'click', async (ele) => {
  const parentEle = ele.target.closest('section');
  const productPopupEle = parentEle.querySelector('.product-popup');
  await axiosGetProducts(ele.target.closest('.portfolio-card').dataset.id);

  document
    .querySelectorAll('[data-slider="product-popup-related-slider"]')
    .forEach((el) => new Swiper(el, popupRelatedProductEleOpt));
  if (productPopupEle) {
    toggleProductPopup(true);
  }
});

attachEvent('.product-popup__close-trigger', 'click', () => {
  toggleProductPopup(false);
});

// Close modal on Escape key
onKeydown('escape', () => {
  toggleProductPopup(false);
});
